import 'jquery';
import $ from 'jquery';
import Vue from 'vue';
import { VueGoodTable } from 'vue-good-table'; // see https://github.com/xaksis/vue-good-table
import 'vue-good-table/dist/vue-good-table.css';
import { Component } from 'vue-property-decorator';
import VueSelect from 'vue-select'; // needed for multiselect not ported yet
import 'vue-select/dist/vue-select.css'; // import css
import { formatDateTime, WindowType } from '../../util';
import { Cell } from '../backend/backendapi';
import { OeeSettings } from './oeeconfig.model';
import OeeService from './oeeconfig.service';

declare var window: WindowType;

@Component({
    name: 'oee',
    components: {
        VueGoodTable,
        VueSelect
    },
})
export default class OeeComponent extends Vue {
    service: OeeService = new OeeService();
    oeeSettingsPage: OeeSettings[] = [];
    selectedIndex: OeeSettings[] = [];
    newSetting: OeeSettings = new OeeSettings();
    cells: Cell[] = [];
    isMaintenance: boolean = true;
    isEdit: boolean = false;

    columnsConfig = [
        {
            label: 'Status',
            field: 'status',
        },
        {
            label: 'Cell',
            field: 'cellName',
        },
        {
            label: 'Db',
            field: 'ignDb',
        },
        {
            label: 'Table',
            field: 'ignTable',
        },
        {
            label: 'Field',
            field: 'ignFieldValue',
        },
        {
            label: 'Last',
            field: 'lastRun',
            type: 'date',
            formatFn: formatDateTime
        }
        //{
        //    label: 'Id',
        //    field: 'id',
        //    type: 'number',
        //}
    ];
    selectConfig = {
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: this.getSelectionTextStr(),
        clearSelectionText: this.getClearStr(),
        disableSelectInfo: false, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
    };

    constructor() {
        super();
        this.selectedIndex = [];
    }

    async mounted(): Promise<void> {
        this.isMaintenance = window.application.check2.isMaintenanceMode
        await this.fetchCells();
        await this.fetchSettings();
        this.handleModalOpenTriggerByUrl();
    }

    private handleModalOpenTriggerByUrl(): void {
        let url = new URL(window.location.href);
        if (!url.searchParams.has('oeesetting')) {
            return;
        }
        let id = parseInt(url.searchParams.get('oeesetting')!);
        let setting = this.oeeSettingsPage.find(e => e.id === id);
        if (setting) {
            this.selectedIndex.splice(0);
            this.selectedIndex.push(setting);
            this.editSelected();

            //remove the search param from url to a reload of this component does not trigger a the modal again
            url.searchParams.delete('oeesetting');
            window.history.pushState(undefined, '', url);
        }
    }

    private fetchSettings(): Promise<void> {
        return this.service.fetchsettings()
            .then(data => {
                this.oeeSettingsPage = data as OeeSettings[];
                console.log(this.oeeSettingsPage);
            });
    }

    private fetchCells(): Promise<void> {
        return this.service.fetchcells()
            .then(data => {
                this.cells = data as Cell[];
            });
    }

    postSetting() {
        console.log("post setting");

        if (this.newSetting != undefined && this.newSetting.fKCellId != undefined && this.newSetting.cellName != undefined) {
            let tmp = this.cells.find(q => q.id === this.newSetting.fKCellId);
            if (tmp !== undefined && tmp.name != undefined) this.newSetting.cellName = tmp.name;
        }

        if (!this.isEdit) {
            this.service.postsetting(this.newSetting);
        } else {
            this.service.updatesetting(this.newSetting);
        }

        this.fetchAndClear();
        $('#addModal').modal('hide'); // caling jqery, be carefull with vue.js and  jqery
        this.isEdit = false;
    }

    deleteSelected() {
        if (this.selectedIndex.length > 0) {
            this.service.deletesettings(this.selectedIndex);
            this.fetchAndClear();
        }
    }

    updateSelected() {
        if (this.selectedIndex.length > 0) {
            this.service.updatesetting(this.selectedIndex[0]);
            this.fetchAndClear();
        }
    }

    editSelected() {
        $('#addModal').modal('show'); // caling jqery, be carefull with vue.js and  jqery
        if (this.selectedIndex.length > 0 && this.selectedIndex[0].id !== undefined) {
            this.newSetting = this.selectedIndex[0];
            console.log(this.newSetting);
            this.isEdit = true;
        }
    }

    clearSelection() {
        this.selectedIndex = [];
    }

    // Fetches the data after 1 second and also clears the inputs etc.s
    fetchAndClear() {
        // Create a new Promise and resolve after 1 seconds
        var myTimerPromise = new Promise((resolve, reject) => {
            setTimeout(resolve, 500);  // "resolve" is already a function, no need for another anonymous function here
        });

        // Fetch data now, within Promise.all()
        Promise.all([myTimerPromise]).then(() => {
            this.fetchSettings();
            this.fetchCells();
            this.clearSelection();
            this.newSetting = new OeeSettings();
        });
    }

    selectionChanged(params) {
        console.log("selection items=" + JSON.stringify(params));
        this.selectedIndex = params.selectedRows;
    }

    getClearStr() {
        return this.$i18n.t('comClear').toString();
    }

    getSelectionTextStr() {
        return this.$i18n.t('comSelectionCnt').toString();
    }

}